module.exports = __webpack_public_path__ + "img/banner4.39ccb60e.png";